(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rich-media"] && !Shopify.designMode) return;
  try {
    (function () {
    function initVideo(video) {
      if (video.dataset.richVideoInit) return;
      video.dataset.richVideoInit = '1';

      var toggle = video.parentElement
        ? video.parentElement.querySelector('[data-rich-video-toggle]')
        : null;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!video.dataset.richPaused) {
                var p = video.play();
                if (p && p.catch) p.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(video);

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) {
            delete video.dataset.richPaused;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.dataset.richPaused = '1';
            video.pause();
          }
        });

        var sync = function () {
          var paused = video.paused;
          toggle.classList.toggle('is-paused', paused);
          toggle.setAttribute(
            'aria-label',
            paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause
          );
        };
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        sync();
      }
    }

    function initAll(root) {
      (root || document).querySelectorAll('video[data-rich-video]').forEach(initVideo);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
